import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeNav = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M14.462 4.015c.88-.77 2.194-.77 3.073 0l9.334 8.166c.506.444.796 1.084.796 1.757v11.394a2.333 2.333 0 0 1-2.333 2.334h-5.333a2.333 2.333 0 0 1-2.334-2.334V20a.333.333 0 0 0-.333-.333h-2.667a.333.333 0 0 0-.333.333v5.334a2.333 2.333 0 0 1-2.333 2.333H6.665a2.333 2.333 0 0 1-2.333-2.334V13.938c0-.672.29-1.312.797-1.755l9.333-8.167Zm1.756 1.505a.333.333 0 0 0-.439 0l-9.333 8.167a.333.333 0 0 0-.114.25v11.396c0 .184.15.333.333.333H12c.184 0 .333-.15.333-.334V20a2.333 2.333 0 0 1 2.333-2.333h2.667a2.333 2.333 0 0 1 2.333 2.333v5.334c0 .184.15.333.334.333h5.333c.184 0 .333-.15.333-.334V13.938a.333.333 0 0 0-.113-.25L16.218 5.52l.659-.753-.659.753Z",
		clipRule: "evenodd"
	})
});
export default SvgHomeNav;
